import React from 'react';
import { ActionButton } from './ActionButton';
import { MiniFollicleCluster } from './MiniFollicleCluster';
import { introScale } from '../data/introScale';
type IntroScreenProps = {
  onStart: () => void;
};
export function IntroScreen({
  onStart
}: IntroScreenProps) {
  return <section className="overflow-hidden rounded-2xl border border-rule bg-white shadow-[0_1px_2px_rgba(28,29,34,0.04),0_8px_24px_-12px_rgba(28,29,34,0.08)]" aria-labelledby="intro-title" data-id="element-158" data-mp="18pupioawzswz">
      <div className="px-5 py-10 md:px-8 lg:px-14 lg:py-14" data-id="element-159" data-mp="1ioajr058niap">
        <h1 id="intro-title" className="max-w-4xl font-serif text-4xl font-normal leading-[1.08] tracking-[-0.015em] text-ink md:text-[56px]" data-id="element-160" data-mp="1ilob0x6m2wqw">
          The goal isn't more follicles. It's the right response.
        </h1>
        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-graphite" data-id="element-161" data-mp="26dd084o4z53m">
          During ovarian stimulation, FSH encourages multiple follicles to develop so oocytes can be retrieved for IVF/ICSI.
          The challenge is balance.
        </p>

        <figure className="mt-10 overflow-hidden rounded-xl border border-rule" data-id="element-162" data-mp="2ow8cjyn9soir">
          <div className="grid md:grid-cols-3" data-id="element-163" data-mp="2tutdk0acjc89">
            {introScale.map((z, i) => <div key={z.title} className={`flex flex-col items-center px-6 pb-7 pt-5 text-center ${z.tint} ${i > 0 ? 'border-t border-rule md:border-l md:border-t-0' : ''} ${i === 1 ? 'md:border-x md:border-target/40' : ''}`} data-id="element-164" data-mp="2yslefjsyy8ol" data-mpi={i}>
                <p className={`text-[13px] font-medium ${z.text}`} data-id="element-165" data-mp="3crbdv639gkg4">{z.label}</p>
                <div className="mt-4" data-id="element-166" data-mp="3hj2twmosj7s0">
                  <MiniFollicleCluster n={z.n} label={`${z.title}: illustrative follicle cluster`} data-id="element-167" data-mp="3hk4htrqwnor5" />
                </div>
                <p className="mt-4 text-sm font-medium text-ink" data-id="element-168" data-mp="3mk8oyr5xb74p">{z.title}</p>
                <p className="mt-1 max-w-[220px] text-sm leading-snug text-graphite" data-id="element-169" data-mp="3qlu98xksenox">{z.body}</p>
              </div>)}
          </div>
        </figure>

        <div className="mt-10 flex flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-170" data-mp="1vg2xrs2l9n9v">
          <div data-id="element-171" data-mp="1rg2cpokzidtu">
            <p className="font-serif text-2xl leading-snug text-ink md:text-3xl" data-id="element-172" data-mp="1rgke0zmi7i8m">The starting dose helps determine where the patient lands.</p>
            <p className="mt-2 text-[15px] text-graphite" data-id="element-173" data-mp="258ifqpdvybur">Different patients can respond differently to the same stimulation approach.</p>
          </div>
          <ActionButton variant="go" onClick={onStart} data-id="element-174" data-mp="2f3isxsuz6i4f">
            Try a patient
          </ActionButton>
        </div>
      </div>
    </section>;
}